import React, { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { usePostTags } from "../hooks";

export default function EditTag() {
  const history = useHistory();
  const [currentColor, setCurrentColor] = useState(null);
  const [currentName, setCurrentName] = useState(null);

  const { id } = useParams();
  const { refreshTags, updateTag, tagIdMap } = usePostTags();

  const finalTag = useMemo(() => {
    if (id && tagIdMap && tagIdMap[id]) {
      setCurrentColor(tagIdMap[id].color || "#000000");
      setCurrentName(tagIdMap[id].name);
      return tagIdMap[id];
    } else {
      return {};
    }
  }, [tagIdMap, id]);

  useEffect(() => {
    return () => {
      (async () => {
        await refreshTags();
      })();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return !finalTag ? null : (
    <>
      <h1>
        Editing tag: "<em>{currentName}</em>"
      </h1>
      <hr />
      <p>
        <label htmlFor="tag-name">Name</label>{" "}
        <input
          id="tag-name"
          onChange={({ target: { value } }) => {
            setCurrentName(value);
          }}
          onBlur={() => {
            updateTag({ ...finalTag, name: currentName });
          }}
          value={currentName}
          type="text"
        />
      </p>
      <p>
        <label htmlFor="tag-color">Color</label>{" "}
        <input
          id="tag-color"
          onChange={({ target: { value } }) => {
            setCurrentColor(value);
          }}
          onBlur={() => {
            updateTag({ ...finalTag, color: currentColor });
          }}
          value={currentColor}
          type="color"
        />
      </p>
      <button onClick={() => history.push(`/tags`)}>Submit</button>
    </>
  );
}
